module.exports = __webpack_public_path__ + "static/augustus_character_wishmastree_01-4cf5c10a77ceaad59a926dbc06fa643b.jpg";